import * as React from 'react';
// Bootstrap Imports
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

export interface ClientManagementCardProps {
    data : any
}

interface InputItemProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label? : string,
    errorMessage? : string,
    children? : any,
    wrapperClassName? : string,
}

const InputItem = (props: InputItemProps) => {
    const inputProps = (({ label, errorMessage, children, wrapperClassName, ...p }) => p)(props);
    return(
    <Card.Text as={Col} sm="12" md="6" lg="6" className={`d-flex ${props.wrapperClassName}`}>
        <Form.Group className="w-100" as={Row}>
            <Form.Label column sm="6">{props.label}</Form.Label>
                <Col className="d-flex flex-row align-items-center" sm="6">
                    <input style={props.children ? {width : "90%"} : {width : "100%"}} className="form-control" {...inputProps} />
                    {
                        props.children&&
                        <div style={{width : "10%"}}>
                            {props.children}
                        </div>
                    }
                </Col>
        </Form.Group>
    </Card.Text>
    )
}

export default InputItem